import { useState, useEffect } from 'react'
import { benefitRulesService } from '../services/benefitRulesService'
import type { BenefitRule } from '../types'

export function useBenefitRule(id: number) {
  const [data, setData] = useState<BenefitRule | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const rule = await benefitRulesService.getById(id)
        setData(rule)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar regla de beneficio')
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [id])

  return { data, isLoading, error }
}
